var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EA4B2162-AA1B-4FD8-8FFD-7A8F33FFEE52") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-849.000000, -306.000000)",
    fill: "#171A33",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EE",
    transform: "translate(295.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "View",
    transform: "translate(546.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,11 C25.5,11 29.94,15.31 31.91,19.58 C32.03,19.8471429 32.03,20.1528571 31.91,20.42 C29.94,24.69 25.5,29 20,29 C14.5,29 10.06,24.69 8.09,20.42 C7.97,20.1528571 7.97,19.8471429 8.09,19.58 C10.06,15.31 14.5,11 20,11 Z M20,15 C17.2385763,15 15,17.2385763 15,20 C15,22.7614237 17.2385763,25 20,25 C22.7600532,24.9966939 24.9966939,22.7600532 25,20 C25,17.2385763 22.7614237,15 20,15 Z M20,17 C21.6568542,17 23,18.3431458 23,20 C23,21.6568542 21.6568542,23 20,23 C18.3431458,23 17,21.6568542 17,20 C17,18.3431458 18.3431458,17 20,17 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/View.6240c8dfeeeea2a52c506e5c68a3b993.svg";
export { ForwardRef as ReactComponent };